"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _core = require("hub-http/middlewares/core");

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _constants = require("settings-ui-sdk/EspSync/constants");

var BASE_PATH = '/esp-sync/v1/oauth';

var portalId = _hubspot.default.get();

var EspSyncOAuthAPI =
/*#__PURE__*/
function () {
  function EspSyncOAuthAPI() {
    (0, _classCallCheck2.default)(this, EspSyncOAuthAPI);
  }

  (0, _createClass2.default)(EspSyncOAuthAPI, null, [{
    key: "getOAuthUrl",
    value: function getOAuthUrl(_ref) {
      var espType = _ref.espType,
          redirectUrl = _ref.redirectUrl;

      if (_constants.EspType.MAILCHIMP_OAUTH === espType) {
        return Promise.resolve({
          authorizeUrl: "https://" + (0, _core.resolveApi)((0, _core.standardApi)('api', 'hubspot')) + "/oauthor/v1/mailchimp/start/crm.v2?portalId=" + portalId + "&appendToFinal=/" + portalId + "/marketing/email-service-provider"
        });
      }

      return _apiClient.default.get(BASE_PATH + "/authorizeUrl", {
        query: {
          espType: espType,
          redirectUrl: redirectUrl
        }
      });
    }
  }]);
  return EspSyncOAuthAPI;
}();

exports.default = EspSyncOAuthAPI;
module.exports = exports.default;